import { BLOG_NEWS_TYPE } from '@/helpers';
import { toIsoDate } from '@/helpers/blog/author';
import ImageCard from '@/components/@general/ImageCard/index.vue';

export default {
  name: 'AuthorArticleCard',
  components: { ImageCard },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    route() {
      return { name: `${this.data.type || BLOG_NEWS_TYPE.INTERESTING}-single`, params: { slug: this.data.slug } };
    },
    isoDate() {
      return toIsoDate(this.data.publishedAt);
    }
  }
};
